import { render, staticRenderFns } from "./PropostaEnviada.vue?vue&type=template&id=708da366&"
import script from "./PropostaEnviada.js?vue&type=script&lang=js&"
export * from "./PropostaEnviada.js?vue&type=script&lang=js&"
import style0 from "./PropostaEnviada.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QImg,QIcon,QRadio});
